module.exports = __webpack_public_path__ + "img/terms-and-conditions.4a296866.svg";